import {
  getTerminal
} from '../actions/terminals'
import axios from 'axios'
import { apiUrl } from '@/api/apiUrl'

import {
  _
} from "vue-underscore"

const state = {
  terminal: [],
  customParams: []
}

const mutations = {
  FETCH_TERMINALS(state, item) {
    state.terminal = item
  },
  FETCH_CP(state, item) {
    state.customParams = item
  }
}

const actions = {
  [getTerminal]: ({
    commit
  }) => {
    return new Promise((resolve, reject) => {
      let config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      axios
        .post(apiUrl + "terminal", {}, config)
        .then(({
          data
        }) => {
          if (data.state_id == 0 && data.total > 0) {
            commit('FETCH_TERMINALS', data.list)
            resolve(data)
          }
        })
        .catch(err => {
          reject(err)
        });
    })
  },
  getCustomParams({
    commit
  }) {
    if (state.terminal && state.terminal.length > 0) {
      let list = state.terminal.filter(el => el.custom_params != null)
      let listCP = []
      list.forEach(el => {
        listCP = _.union(listCP, el.custom_params)
      });
      let customParams = _.uniq(listCP, false, el => el.key)
      commit('FETCH_CP', customParams)
    } else {
      commit('FETCH_CP', null)
    }
  }
}

const getters = {
  terminalList(state) {
    return state.terminal.sort((a, b) => {
      if (a.name > b.name) return 1
      if (a.name < b.name) return -1
      return 0
    })
  },
  terminalName: state => id => {
    if (state.terminal != undefined && state.terminal.length > 0) {
      let item = state.terminal.find(el => el.id === id)
      if (item != undefined) return item['name']
      else return id
    } else {
      return ""
    }
  },
  terminalReceipt: state => id => {
    if (state.terminal != undefined && state.terminal.length > 0 && id != null && id != "") {
      let item = state.terminal.find(el => el.id === id)
      if (item != undefined) return item['is_receipt']
      else return false
    } else {
      return false
    }
  },
  terminalSplit: state => {
    if (state.terminal != undefined && state.terminal.length > 0) {
      let temp = state.terminal.filter(el => el.is_split == true)
      if (temp && temp.length > 0) return true
      else return false
    }
  },
  customParams: state => {
    return state.customParams
  },
  terminalTax: state => id => {
    if (state.terminal != undefined && state.terminal.length > 0 && id) {
      let item = state.terminal.find(el => el.id === id)
      if (item) return item['tax']
      else return false
    } else {
      return false
    }
  },
  decisionAF: state => {
    if (state.terminal && state.terminal.length > 0) {
      let list = state.terminal.filter(el => el.is_antifraud)
      if (list.length > 0) return true
      else return false
    } else return false
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}